import { dateFormat } from "@website/utils/date-format";
import toString from "lodash-es/toString";

export const displayTimeWithHourAndMinute = (date: string): string => {
  const localTimeString = new Date(date).toLocaleTimeString("fa-IR", {
    hour: "2-digit",
    minute: "2-digit"
  });
  if (localTimeString === "Invalid Date") return "۰۰:۰۰";
  return localTimeString;
};
export const displayDateWithDayAndMonth = (date: string): string => {
  const localTimeString = new Date(date).toLocaleDateString("fa-IR", {
    day: "2-digit",
    month: "long"
  });
  if (localTimeString === "Invalid Date") return "۱ فروردین";
  return localTimeString;
};
export const calculateDifferencesNight = (dateFrom: string, dateTo: string) => {
  const date1 = new Date(dateFrom);
  const date2 = new Date(dateTo);
  const differenceInTime = date2.getTime() - date1.getTime();
  return Math.round(differenceInTime / (1000 * 3600 * 24));
};

export const convertStringToDatePickerValue = (stringDate: string) => {
  const defaultLocale = "fa";
  return {
    year: Number(
      dateFormat(stringDate, {
        locale: defaultLocale,
        numberConvert: false,
        template: "yyyy"
      })
    ),
    month: Number(
      dateFormat(stringDate, {
        locale: defaultLocale,
        numberConvert: false,
        template: "MM"
      })
    ),
    day: Number(
      dateFormat(stringDate, {
        locale: defaultLocale,
        numberConvert: false,
        template: "dd"
      })
    ),
    dateTime: toString(
      dateFormat(stringDate, {
        locale: "en",
        template: "yyyy-MM-dd"
      })
    )
  };
};
